import { AfterViewInit, Directive, OnDestroy, ViewChild } from '@angular/core';
import { MatTab,  MatTabGroup,  MatTabHeader } from '@angular/material/tabs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormChangeStateService } from './form-change-state.service';
import { UnsavedChangesWarningDialogResponse } from './unsaved-changes-warning-dialog.component';

@UntilDestroy()
@Directive()
export abstract class BaseTabStateChangeDetection implements AfterViewInit, OnDestroy {
    @ViewChild(MatTabGroup, { static: false }) tabGroup: MatTabGroup;

    protected constructor(
        protected formChangeStateService: FormChangeStateService,
    ) {
    }

    ngAfterViewInit(): void {
        this.tabGroup._handleClick = this.interceptTabChange.bind(this);
    }

    /**
     * finally it should call method `this.applyTab(tab, tabHeader, index);` when tab is allowed to navigate
     **/
    abstract handleWarning(response: UnsavedChangesWarningDialogResponse, tab: MatTab, tabHeader: MatTabHeader, index: number): void;

    private interceptTabChange(tab: MatTab, tabHeader: MatTabHeader, index: number): void {
        if (this.formChangeStateService.isFormChanged()) {
            this.formChangeStateService.showWarning().pipe(untilDestroyed(this))
            .subscribe((response: UnsavedChangesWarningDialogResponse) => {
                this.handleWarning(response, tab, tabHeader, index);
            });
        } else {
            this.applyTab(tab, tabHeader, index);
        }
    }

    applyTab(tab: MatTab, tabHeader: MatTabHeader, index: number) {
        MatTabGroup.prototype._handleClick.apply(this.tabGroup, [tab, tabHeader, index]);
    }

    ngOnDestroy(): void {
        this.formChangeStateService.setFormChanged(false);
        this.formChangeStateService.setFormValidity(false);
    }
}
